import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DependentModule } from "../shared/dependent.module";
import { AlbumPouchDb } from './album.pouchService';
import { AlbumComponent } from './album.component';
import { SortablejsModule } from 'angular-sortablejs/dist';
import {DndModule} from 'ng2-dnd';
@NgModule({
  imports: [
    CommonModule,
    DependentModule,
    SortablejsModule,
    DndModule.forRoot()
  
  ],
  declarations: [AlbumComponent],
  entryComponents: [AlbumComponent],
  providers: [AlbumPouchDb],
// exports:[SortablejsModule,DndModule]
})
export class AlbumModule { }


// WEBPACK FOOTER //
// ./src/app/album/album.module.ts